let allVariantsElement = document.getElementById('allVariants');
if(allVariantsElement) {
  const allVariants = JSON.parse(allVariantsElement.textContent);

  document.querySelectorAll(".product__options input[type='radio']").forEach(radio => {
    radio.addEventListener('change', (e)=> {  

      /* -----------------------------------------
         1) Correct radio behavior
      --------------------------------------------*/
      const name = e.target.name;
      document.querySelectorAll(`.product__options input[name="${name}"]`)
        .forEach(r => (r.checked = false));
      e.target.checked = true;

      /* -----------------------------------------
         2) Collect selected options
      --------------------------------------------*/
      let selectedOptions = [];
      document.querySelectorAll(".product__options input[type='radio']:checked")
        .forEach(r => selectedOptions.push(r.value));

      /* -----------------------------------------
         3) Find matched variant
      --------------------------------------------*/
      let matchedVariant = allVariants.find(variant => {
        return variant.options.every((option, i) => option === selectedOptions[i]);
      });

      if (!matchedVariant) return; // SAFE EXIT

      /* -----------------------------------------
         4) SET ACTIVE SIZE AVAILABILITY PER COLOR
      --------------------------------------------*/
      const optionNames = window.PRODUCT_OPTION_NAMES || [];
      const colorIndex = optionNames.findIndex(n => n.toLowerCase().includes('color'));
      const sizeIndex  = optionNames.findIndex(n => n.toLowerCase().includes('size'));

      if (colorIndex !== -1 && sizeIndex !== -1) {
        const selectedColor = matchedVariant.options[colorIndex];
        const variantsForColor = allVariants.filter(v => v.options[colorIndex] === selectedColor);
        const selectedColorText = document.querySelector('.product__selected-color span');
        
            if (selectedColorText) {
              selectedColorText.textContent = matchedVariant.options[colorIndex];
            }

        document.querySelectorAll('.product-radio-size').forEach(radio => {
          const sizeVal = radio.value;
          const label = document.querySelector(`label[for="${radio.id}"]`);
          const v = variantsForColor.find(v => v.options[sizeIndex] === sizeVal);
          const available = !!(v && v.available);

          radio.disabled = !available;

          if (label) {
            label.style.opacity = available ? '' : '0.7';
            label.style.textDecoration = available ? '' : 'line-through';
          }
        });
      }

      /* -----------------------------------------
         5) Update gallery
      --------------------------------------------*/
      const code = e.target.dataset.code;
      if (window.ProductGallery && window.ProductGallery.updateByColorCode) {
        window.ProductGallery.updateByColorCode(code);
      }

      /* -----------------------------------------
         6) Update hidden variant ID in form
      --------------------------------------------*/
      let formVariantId = document.getElementById('product-id'); 
      if (formVariantId) {
        formVariantId.value = matchedVariant.id;
      }

      /* -----------------------------------------
         7) Update URL
      --------------------------------------------*/
      let url = new URL(window.location.href);
      url.searchParams.set("variant", matchedVariant.id);
      window.history.replaceState(null, null, url.toString());

      /* -----------------------------------------
         8) UPDATE PRICE (compare & final)
      --------------------------------------------*/
      let comparePrice = document.querySelector('.product__compare-price');       
      let finalPrice = document.querySelector('.product__final-price');
      let percentageEl = document.querySelector('.product__discount-percentage');

      const hasDiscount = matchedVariant.compare_at_price > matchedVariant.price;

      if (comparePrice) {
        if (hasDiscount) {
          comparePrice.textContent = Shopify.formatMoney(matchedVariant.compare_at_price);
          comparePrice.classList.remove('product__price-hide');
          finalPrice.classList.add('product__price-discounted');
        } else {
          comparePrice.classList.add('product__price-hide');
          finalPrice.classList.remove('product__price-discounted');
        }
      }

      if (finalPrice) {
        finalPrice.textContent = Shopify.formatMoney(matchedVariant.price);
      }

      /* -----------------------------------------
         9) UPDATE DISCOUNT BADGE (safe)
      --------------------------------------------*/
/* -----------------------------------------
   UPDATE DISCOUNT BADGE (Jacadi Snippet Compatible)
--------------------------------------------*/
    const badgeWrapper = document.querySelector('.product__discount-percentage');

    if (badgeWrapper) {

    const sectionId = 'template--26276583539027__main'; 
    // Section ID bez "shopify-section-" prefiksa

    const renderUrl = `${window.location.pathname}?variant=${matchedVariant.id}&sections=${sectionId}`;

    fetch(renderUrl)
        .then(res => res.json())
        .then(data => {
        const sectionHtml = data[sectionId];
        if (!sectionHtml) return;

        // Napravimo temp wrapper da parsiramo HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = sectionHtml;

        // Iz sekcije izvlačimo SAMO badge wrap
        const newBadgeWrap = tempDiv.querySelector('.product__discount-percentage');

        if (newBadgeWrap) {
            // Zamjena badge HTML-a
            badgeWrapper.innerHTML = newBadgeWrap.innerHTML;
        }
        })
        .catch(err => console.error("Badge Render Error:", err));
    }


      /* -----------------------------------------
         10) Najniža cijena zadnjih 30 dana (safe)
      --------------------------------------------*/
      const lowestPriceWrapper = document.querySelector('.custom-price');
      if (lowestPriceWrapper) {
        const lowestPriceEl = lowestPriceWrapper.querySelector('span');
        if (lowestPriceEl) {
          if (hasDiscount) {
            lowestPriceEl.textContent =
              "Najniža cijena zadnjih 30 dana: " + Shopify.formatMoney(matchedVariant.compare_at_price);
            lowestPriceWrapper.style.display = '';
          } else {
            lowestPriceWrapper.style.display = 'none';
          }
        }
      }

      /* -----------------------------------------
         11) Update Add to Cart Button
      --------------------------------------------*/
      let submitBtn = document.querySelector('#product__add-to-cart');       
      if (submitBtn) {
        if (matchedVariant.available) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('product__submit-disabled');
          if (submitBtn.dataset.atc) submitBtn.textContent = submitBtn.dataset.atc;
        } else {
          submitBtn.disabled = true;
          submitBtn.classList.add('product__submit-disabled');
          if (submitBtn.dataset.oos) submitBtn.textContent = submitBtn.dataset.oos;
        }
      }

    });
  });
}

/* ------------------------------------------------
   DESCRIPTION TABS
--------------------------------------------------*/
const tabs = document.querySelectorAll('.product__description-tab');

if (tabs.length) {
  tabs.forEach((tabBtn) => {
    tabBtn.addEventListener('click', (e) => {

      tabs.forEach((t) => t.classList.remove('product__description-active'));
      e.currentTarget.classList.add('product__description-active');

      document.querySelectorAll('.product__accordion')
        .forEach((acc) => acc.classList.add('product__accordion-tab-hidden'));

      const targetTab = tabBtn.getAttribute('data-tab');
      const activeAccordion = document.querySelector(`.product__accordion[data-tab="${targetTab}"]`);
      if (activeAccordion) {
        activeAccordion.classList.remove('product__accordion-tab-hidden');
      }
    });
  });
}
